"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["WX_PAY"] = 101] = "WX_PAY";
    PaymentMethod[PaymentMethod["WX_H5_PAY"] = 102] = "WX_H5_PAY";
    PaymentMethod[PaymentMethod["WX_MINI_APP_PAY"] = 103] = "WX_MINI_APP_PAY";
    PaymentMethod[PaymentMethod["WX_APP_PAY"] = 104] = "WX_APP_PAY";
    PaymentMethod[PaymentMethod["POINT"] = 201] = "POINT";
    PaymentMethod[PaymentMethod["REDEEM_CODE"] = 301] = "REDEEM_CODE";
    PaymentMethod[PaymentMethod["THIRD_PARTY_ORDER"] = 401] = "THIRD_PARTY_ORDER";
    PaymentMethod[PaymentMethod["ALIPAY_UNITE"] = 501] = "ALIPAY_UNITE";
    PaymentMethod[PaymentMethod["ALIPAY_WAP"] = 502] = "ALIPAY_WAP";
    PaymentMethod[PaymentMethod["ALIPAY_APP"] = 503] = "ALIPAY_APP";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var WechatPaymentTradeType;
(function (WechatPaymentTradeType) {
    WechatPaymentTradeType["WECHAT"] = "JSAPI";
    WechatPaymentTradeType["MINI_APP"] = "JSAPI";
    WechatPaymentTradeType["H5"] = "MWEB";
})(WechatPaymentTradeType = exports.WechatPaymentTradeType || (exports.WechatPaymentTradeType = {}));
exports.PaymentMethodName = (_a = {},
    _a[PaymentMethod.WX_PAY] = '微信支付',
    _a[PaymentMethod.WX_H5_PAY] = '微信支付',
    _a[PaymentMethod.WX_MINI_APP_PAY] = '微信支付',
    _a[PaymentMethod.WX_APP_PAY] = '微信支付',
    _a[PaymentMethod.POINT] = '积分支付',
    _a[PaymentMethod.REDEEM_CODE] = '兑换码支付',
    _a[PaymentMethod.THIRD_PARTY_ORDER] = '第三方订单支付',
    _a[PaymentMethod.ALIPAY_UNITE] = '支付宝支付',
    _a[PaymentMethod.ALIPAY_WAP] = '支付宝支付',
    _a[PaymentMethod.ALIPAY_APP] = '支付宝支付',
    _a);
//# sourceMappingURL=payment.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/payment.js
// module id = 1012
// module chunks = 0